<div class="form-section">
  <label [for]="id" [class.required-field]="required">{{ label }}</label>

  <!-- Hidden file input -->
  <input
    type="file"
    [id]="id"
    [name]="name"
    (change)="onFileSelected($event)"
    [accept]="acceptedFormats.join(',')"
    style="display: none;">

  <!-- Upload area when no avatar and camera not active -->
  <div *ngIf="!avatar && !isCameraActive" class="upload-container">
    
    <!-- Upload progress (shown during upload) -->
    <div *ngIf="isUploading" class="upload-progress-overlay">
      <div class="upload-progress">
        <div class="progress-icon">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <div class="progress-text">
          <span>上傳中...</span>
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="uploadProgress"></div>
          </div>
          <span class="progress-percentage">{{ uploadProgress }}%</span>
        </div>
      </div>
    </div>

    <!-- File upload section -->
    <div class="upload-section file-upload-section" 
         [class]="getDisplayModeClass()"
         [class.drag-over]="isDragOver"
         [class.uploading]="isUploading"
         (click)="!isUploading && triggerFileSelection()"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)">
      
      <div class="upload-content">
        <div class="upload-icon">
          <i class="fas fa-folder-open"></i>
        </div>
        <div class="upload-text">
          <span class="primary-text">選擇檔案</span>
          <span class="secondary-text">點擊上傳照片</span>
        </div>
      </div>
    </div>

    <!-- Camera upload section -->
    <div *ngIf="isCameraSupported()" 
         class="upload-section camera-upload-section"
         [class]="getDisplayModeClass()"
         [class.uploading]="isUploading"
         (click)="!isUploading && startCamera()">
      
      <div class="upload-content">
        <div class="upload-icon">
          <i class="fas fa-camera"></i>
        </div>
        <div class="upload-text">
          <span class="primary-text">拍照上傳</span>
          <span class="secondary-text">開啟攝影機</span>
        </div>
      </div>
    </div>
    
  </div>

  <!-- Camera interface -->
  <div *ngIf="isCameraActive" class="camera-interface" [class]="getDisplayModeClass()">
    
    <!-- Camera preview -->
    <div *ngIf="showCameraPreview" class="camera-preview">
      <video [id]="'camera-' + id" 
             class="camera-video" 
             autoplay 
             playsinline>
      </video>
      
      <div class="camera-controls">
        <button type="button" 
                class="control-btn capture-btn"
                (click)="capturePhoto()">
          <i class="fas fa-camera"></i>
          <span>拍照</span>
        </button>
        
        <button type="button" 
                class="control-btn cancel-btn"
                (click)="stopCamera()">
          <i class="fas fa-times"></i>
          <span>取消</span>
        </button>
      </div>
    </div>

    <!-- Captured photo preview -->
    <div *ngIf="capturedImage && !showCameraPreview" class="captured-preview">
      <img [src]="capturedImage" 
           alt="Captured photo" 
           class="captured-image">
      
      <div class="captured-controls">
        <button type="button" 
                class="control-btn retake-btn"
                (click)="retakePhoto()">
          <i class="fas fa-redo"></i>
          <span>重拍</span>
        </button>
        
        <button type="button" 
                class="control-btn confirm-btn"
                (click)="confirmPhoto()">
          <i class="fas fa-check"></i>
          <span>確認上傳</span>
        </button>
      </div>
    </div>

    <!-- Hidden canvas for photo capture -->
    <canvas [id]="'canvas-' + id" style="display: none;"></canvas>
  </div>

  <!-- Avatar preview when uploaded -->
  <div *ngIf="avatar && !isUploading" class="avatar-preview-container">
    <div class="avatar-preview" [class]="getDisplayModeClass()">
      <!-- Loading placeholder -->
      <div *ngIf="!avatar.previewUrl" class="loading-placeholder">
        <i class="fas fa-spinner fa-spin"></i>
        <span>載入預覽中...</span>
      </div>

      <!-- Avatar image -->
      <img *ngIf="avatar.previewUrl"
           [src]="avatar.previewUrl"
           [alt]="avatar.fileName"
           class="avatar-image"
           onerror="this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjYwIiBmaWxsPSIjZjVmNWY1Ii8+CjxjaXJjbGUgY3g9IjYwIiBjeT0iNDgiIHI9IjE4IiBmaWxsPSIjY2NjIi8+CjxwYXRoIGQ9Ik0yNCA5NmMwLTE5Ljg4MiAxNi4xMTgtMzYgMzYtMzZoMjRjMTkuODgyIDAgMzYgMTYuMTE4IDM2IDM2djBoLTk2djB6IiBmaWxsPSIjY2NjIi8+Cjwvc3ZnPg=='">

      <!-- Overlay for hover effects -->
      <div class="avatar-overlay">
        <div class="overlay-actions">
          <button type="button"
                  class="action-btn change-btn"
                  (click)="triggerFileSelection()"
                  title="重新上傳">
            <i class="fas fa-camera"></i>
          </button>
          <button type="button"
                  class="action-btn remove-btn"
                  (click)="removeAvatar()"
                  title="移除照片">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Avatar info -->
    <div class="avatar-info">
      <div class="file-name">{{ avatar.fileName }}</div>
      <div class="file-details">
        <span class="file-size">{{ formatFileSize(avatar.fileSize) }}</span>
        <span class="upload-date">{{ avatar.uploadedAt | date:'yyyy-MM-dd HH:mm' }}</span>
      </div>
    </div>
  </div>
</div>
